import {
  REQUEST_MESSAGES,
  RECEIVE_MESSAGES,
  CREATE_MESSAGE
} from 'constants/ActionTypes'

const messagesReducer = (state = { messages: [] }, action) => {
  switch (action.type) {
    case REQUEST_MESSAGES:
      return Object.assign({}, state, {
        isLoading: true,
        didInvalidate: false
      })
    case RECEIVE_MESSAGES:
      return Object.assign({}, state, {
        isLoading: false,
        didInvalidate: false,
        messages: action.messages,
        lastUpdated: action.receivedAt
      })
    case CREATE_MESSAGE:
      return Object.assign({}, state, {
        messages: [
          {
            content_for_display: action.values.content,
            subjectID: action.values.subjectID,
            who_is_sender: action.values.currentUserRole,
            time_ago: 'Less Than A Minute Ago',
            sender_name: 'You',
            sent_by_me: true
          },
          ...state.messages
        ]
      })
    default:
      return state
  }
}

export default messagesReducer
